<script setup>
import { ref } from 'vue'
import Textarea from 'primevue/textarea'
import Message from 'primevue/message'
import Button from 'primevue/button'
import { useToast } from 'primevue/usetoast'

import { useConversationsStore } from '@/stores/messages/conversations.js'
import messagesApi from '@/api/messagesApi.js'
import Card from "primevue/card";

const props = defineProps({
  userId: { type: Number, required: true },
  autofocus: { type: Boolean, default: false },
})

const toast = useToast()
const conversations = useConversationsStore()
const commentText = ref('')
const error = ref('')
const sending = ref(false)

async function onSubmit(e) {
  e?.preventDefault?.()
  error.value = ''
  const body = String(commentText.value || '').trim()
  if (!body) { error.value = 'Введите текст сообщения'; return }
  sending.value = true
  try {
    const conversation_id = await conversations.ensure1to1(props.userId, { forceNew: true })
    if (!conversation_id) {
      error.value = 'Не удалось создать беседу'
      toast.add({ severity: 'error', summary: 'Ошибка', detail: error.value, life: 3000 })
      return
    }

    const realMessage = await messagesApi.sendMessage(conversation_id, { body })


    conversations.upsertFromMessageEvent({ conversation_id, message: realMessage })
    await conversations.hydrateConversationMeta(conversation_id)

    commentText.value = ''
    toast.add({ severity: 'success', summary: 'Сообщение отправлено', life: 1800 })
  } catch (e) {
    const detail = e?.response?.data?.detail || e?.message || ''
    error.value = 'Не удалось отправить сообщение' + (detail ? `: ${detail}` : '')
    toast.add({ severity: 'error', summary: 'Ошибка', detail: error.value, life: 3000 })
  } finally {
    sending.value = false
  }
}
</script>

<template>
  <Card class="w-full max-w-md mx-auto shadow p-0 overflow-hidden">
    <template #content>
  <form @submit="onSubmit" class="flex flex-col gap-4 flex-shrink-0 w-full">
    <div class="flex flex-col gap-1">
      <Textarea
          v-model="commentText"
          rows="3"
          autoResize
          class="w-full"
          placeholder="Напишите мне..."
          style="resize: none"
          :autofocus="autofocus"
      />
      <Message v-if="error" severity="error" size="small" variant="simple">{{ error }}</Message>
    </div>
    <Button type="submit" :disabled="sending" severity="info" variant="outlined" rounded label="Отправить" />
  </form>
      </template>
  </Card>
</template>
